import type { ReactNode } from 'react'
import styles from './Feedback.module.css'

export type FeedbackTone = 'correct' | 'incorrect' | 'info'

const GLYPH: Record<FeedbackTone, string> = {
  correct: '✓',
  incorrect: '✗',
  info: 'i',
}

/**
 * Immediate, explanatory feedback shown after a learner acts. Announced to
 * screen readers via a live region; meaning is carried by a glyph and text, not
 * color alone. Reused by multiple-choice, sort-items, and short-response.
 */
export function Feedback({ tone, children }: { tone: FeedbackTone; children: ReactNode }) {
  return (
    <div className={`${styles.feedback} ${styles[tone]}`} role="status" aria-live="polite">
      <span className={styles.glyph} aria-hidden="true">
        {GLYPH[tone]}
      </span>
      <div className={styles.body}>{children}</div>
    </div>
  )
}
